export const allowedEmails = [ 
    'roberto.noya@realstate.com',
    'aytsistema@gmail.com',
    'berbelimoveis@gmail.com',
    'berbel.alexsandro@gmail.com'
];